export default __webpack_public_path__ + "static/media/Imogen 9781846164972.7948a236.jpg";